module.exports = __webpack_public_path__ + "img/greatseal-pixel.41e0524f.png";